module.exports = __webpack_public_path__ + "static/media/valentinapuglieseface.edae1de3.webp";